import React from 'react';
import { Collapse, ListGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FilterSection = ({ title, isOpen, toggle, children }) => (
  <ListGroup.Item>
    <div className="filter-section">
      <div
        className="filter_header my-1 d-flex justify-content-between align-items-center"
        onClick={toggle}
        role="button"
      >
        {title}
        <FontAwesomeIcon icon={isOpen ? 'angle-up' : 'angle-down'} size="lg" />
      </div>
      <Collapse in={isOpen}>
        <div>{children}</div>
      </Collapse>
    </div>
  </ListGroup.Item>
);

export default FilterSection;
